import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "../Modal";
import VideoDetail from "../videos/VideoDetail";
import OrbitalLoader from "../common/OrbitalLoader";
import { audiencesService } from "../../services/audiences";

const VideoDetailModal = ({ audienceHash, videoHash, baseUrl }) => {
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    if (!audienceHash || !videoHash) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setLoadError(false);
    audiencesService.getAudienceVideo(
      audienceHash,
      videoHash,
      (response) => {
        setItem(response.data);
        setLoading(false);
      },
      () => {
        setLoadError(true);
        setLoading(false);
      }
    );
  }, [audienceHash, videoHash]);

  if (!videoHash) return null;

  if (loading) {
    return (
      <Modal onClose={() => navigate(baseUrl)} maxWidth="max-w-4xl">
        <div className="flex items-center justify-center min-h-[200px]">
          <OrbitalLoader size={192} />
        </div>
      </Modal>
    );
  }

  if (loadError || !item) {
    return (
      <Modal onClose={() => navigate(baseUrl)} maxWidth="max-w-4xl">
        <div className="py-8 text-center text-theme-text">
          <p className="opacity-80">{loadError ? "Video not found or you don't have access." : "No data."}</p>
        </div>
      </Modal>
    );
  }

  return (
    <Modal onClose={() => navigate(baseUrl)} maxWidth="max-w-4xl">
      <div className="max-h-[85vh] overflow-y-auto">
        <VideoDetail item={item} audienceHash={audienceHash} />
      </div>
    </Modal>
  );
};

export default VideoDetailModal;
